
































import {Component, Prop} from 'vue-property-decorator';
import Vue from 'vue';

@Component({})
export default class FormActions extends Vue {
    @Prop({type: Boolean, required: true}) dirty!: boolean
    @Prop({type: Boolean, required: true}) showBack!: boolean
    @Prop({type: Boolean, required: true}) lastPage!: boolean
    @Prop({type: String, required: true}) saveStatus!: string
    @Prop({type: String, required: true}) saveStatusClass!: string

    get nextButtonLabel(): string {
        if (this.lastPage) {
            return 'Save & Complete';
        }

        return 'Save & Continue';
    }
}
